import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAuditable } from '../../models/extension.model';
import { FieldsetModule } from 'primeng/fieldset';
import { TagModule } from 'primeng/tag';
import { ChipModule } from 'primeng/chip';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'dc-auditable-viewer',
  template: `
    @if (data(); as audit) {
    <p-fieldset legend="Audit Information" [toggleable]="true" [collapsed]="true">
      <div class="grid text-sm">
        <div class="col-12 md:col-6 flex flex-column gap-2">
          <label class="font-semibold">Author</label>
          <p-chip [label]="audit.authorEmail" [image]="'https://i.pravatar.cc/40?u=' + audit.createdBy" />
        </div>

        <div class="col-12 md:col-6 flex flex-column gap-2">
          <label class="font-semibold">Last update by</label>
          <p-chip [label]="audit.updatedBy" [image]="'https://i.pravatar.cc/40?u=' + audit.updatedBy" />
        </div>

        <div class="col-12 md:col-6 flex flex-column gap-2">
          <label class="font-semibold">Creation date</label>
          <span>{{ audit.createdAt | date : 'medium' }}</span>
        </div>

        <div class="col-12 md:col-6 flex flex-column gap-2">
          <label class="font-semibold">Last update date</label>
          <span>{{ audit.updatedAt | date : 'medium' }}</span>
        </div>

        @if(audit.generatedByIA) {
        <div class="col-12 mt-2">
          <p-tag severity="info">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-sparkles"></i>
              <span>Generated by AI</span>
            </div>
          </p-tag>
        </div>
        @if(audit.prompt) {
        <div class="col-12 mt-2">
          <div class="flex flex-column gap-2">
            <label class="font-semibold">Prompt</label>
            <p class="m-0 surface-100 p-2 border-round" style="white-space: pre-wrap;">
              {{ audit.prompt }}
            </p>
          </div>
        </div>
        } }
      </div>
    </p-fieldset>
    }
  `,
  standalone: true,
  imports: [CommonModule, FieldsetModule, TagModule, ChipModule, AvatarModule],
})
export class DcAuditableViewerComponent {
  data = input.required<IAuditable>();
}
